import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.authService.getCurrentUserAsync()).pipe(
      switchMap(currentUser => {
        let authReq = req;
        if (currentUser) {
          authReq = req.clone({
            setHeaders: {
              'Content-Type': 'application/json',
              'X-User-Login': currentUser.login
            }
          });

          // ✅ NUEVO LOG: usuario que viaja en cada request
          console.log('[AuthInterceptor] Header X-User-Login ->', currentUser.login);
        } else {
          authReq = req.clone({ setHeaders: { 'Content-Type': 'application/json' } });

          // ✅ NUEVO LOG si no hay usuario
          console.warn('[AuthInterceptor] No hay usuario logueado, request sin X-User-Login');
        }

        return next.handle(authReq);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authService.logout();
          this.router.navigate(['/auth/login']);
        }
        return throwError(() => error);
      })
    );
  }
}
